import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { PosCreatePagesFormsControllerModule } from './forms/controllers/PosCreatePagesFormsController';

export const PosCreatePagesView = angular
  .module('acme.view.application.pos.create.pages', [
    uiRouter,
    'ui.bootstrap',
    'ui.scrollfix',
    'acme.common.directive.customTypeahead',
    'acme.view.application.pos.create.pages.controllers',
    PosCreatePagesFormsControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.pos.create.pages',
      url: '/pages',
      views: {
        'subview-main': {
          controller: 'PosCreatePagesController',
          templateUrl: 'views/application/views/pos/create/pages/pages.tpl.html',
        },
      },
      data: {
        pageTitle: 'Point of Sale Configurator',
      },
    });

    $stateProvider.state({
      name: 'application.pos.edit.pages',
      url: '/pages',
      views: {
        'subview-main': {
          controller: 'PosCreatePagesController',
          templateUrl: 'views/application/views/pos/create/pages/pages.tpl.html',
        },
      },
      data: {
        pageTitle: 'Point of Sale Configurator',
      },
    });
  }).name;
